export default __webpack_public_path__ + "static/media/errorM.f9a6ae2d.webp";